<template>
    <div id="audio-player-container">
        <nonfiction-player
            v-if="audioSources.length"
            ref="insigthPlayer"
            :sources="selectedAudio"
            @end="onPlaybackEnd"
            @play="onPlay"
            @pause="onPause"
            @load="onLoad"
            @stop="onStop"
        />
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import _isEmpty from "lodash/isEmpty";
import _get from "lodash/get";
import playerEventsMixins from "./playerEventsMixins";

export default {
    name: "PlayerContainer",
    components: {
        nonfictionPlayer: () => import(/* webpackChunkName: "nonfiction-player"*/"@c/audio-player/player")
    },
    mixins: [playerEventsMixins],
    computed:{
        ...mapState({
            selectedAudioSource: state => state.NonfictionPlayer.selectedAudioSource,
            audioSources: state => state.NonfictionPlayer.audioSources,
            bookInsight: state => state.NonfictionPlayer.bookInsight,
            showReaderMode: state => state.NonfictionReader.showReaderMode,
            elapsedDuration: state => state.NonfictionPlayer.elapsedDuration
        }),
        ...mapGetters({
            currentAudioSource: "NonfictionPlayer/currentAudioSource"
        }),
        selectedAudio() {
            if (this.audioSources.length) {
                return this.audioSources[this.selectedAudioSource].audioSrc;
            }
            return [];
        }
    },
    watch: {
        showReaderMode(currentVal, oldVal) {
            if (oldVal && currentVal != oldVal) {
                this.onStop();
            }
        }
    },
    beforeDestroy() {
        this.onStop();
    },
    methods: {
        onLoad() {
            if (!_isEmpty(this.$store.state.NonfictionPlayer.currentAudioState)) {
                this.$store.dispatch("NonfictionPlayer/restoreCurrentAudioState");
            }
        },
        onPlay() {
            const album = this.bookInsight.title;
            const title = this.audioSources[this.selectedAudioSource].title;
            const artist = this.bookInsight.authors.map((author) => author.name).join(", ");
            const artworkSrc = _get(this.bookInsight, "external_book.cover_url", "");
            let artwork = [] ;
            if (artworkSrc.length) {
                artwork = [{ src: artworkSrc }];
            }
            if ("mediaSession" in navigator) {
                navigator.mediaSession.metadata = new MediaMetadata({
                    album,
                    artist,
                    artwork,
                    title
                });
                navigator.mediaSession.setActionHandler("play", this.play);
                navigator.mediaSession.setActionHandler("pause", this.pause);
                navigator.mediaSession.setActionHandler("seekbackward", this.rewind);
                navigator.mediaSession.setActionHandler("seekforward", this.forward);
                navigator.mediaSession.setActionHandler("previoustrack", this.previoustrack);
                navigator.mediaSession.setActionHandler("nexttrack", this.nextTrack);
                navigator.mediaSession.playbackState = "playing";
            }

            this.$_dispatchPlayerActionEvent("play", this.actionEventProps);
            this.$_dispatchPlayerActionEvent("progress", this.actionEventProps);
        },
        onPause() {
            this.$_dispatchPlayerActionEvent("pause", this.actionEventProps);
            this.$_dispatchPlayerActionEvent("progress", this.actionEventProps);
        },
        onPlaybackEnd() {
            this.$store.dispatch("NonfictionPlayer/setPlaying", false);
            if (this.audioSources.length > (this.selectedAudioSource + 1)) {
                this.$store.dispatch("NonfictionPlayer/setSelectedAudioSource", (this.selectedAudioSource + 1)).then(() => {
                    this.$store.dispatch("NonfictionPlayer/setPlaying", true);
                    this.$refs["insigthPlayer"].play();
                });
            }
        },
        play() {
            this.$store.dispatch("NonfictionPlayer/setPlaying", true);
            if ("mediaSession" in navigator) {
                navigator.mediaSession.playbackState = "playing";
            }
        },
        pause() {
            this.$store.dispatch("NonfictionPlayer/setPlaying", false);
            if ("mediaSession" in navigator) {
                navigator.mediaSession.playbackState = "paused";
            }
        },
        forward() {
            this.$refs["insigthPlayer"].forward();
        },
        rewind() {
            this.$refs["insigthPlayer"].rewind();
        },
        nextTrack() {
            this.$store.dispatch("NonfictionPlayer/setPlaying", false);
            if (this.audioSources.length > (this.selectedAudioSource + 1)) {
                this.$store.dispatch("NonfictionPlayer/setSelectedAudioSource", (this.selectedAudioSource + 1));
            }
        },
        previoustrack() {
            this.$store.dispatch("NonfictionPlayer/setPlaying", false);
            if (this.audioSources.length && (0 >= (this.selectedAudioSource - 1))) {
                this.$store.dispatch("NonfictionPlayer/setSelectedAudioSource", (this.selectedAudioSource - 1));
            }
        },
        onStop() {
            if ("mediaSession" in navigator) {
                navigator.mediaSession.metadata = null;
                navigator.mediaSession.playbackState = "none";
                navigator.mediaSession.setActionHandler("play", function() {});
                navigator.mediaSession.setActionHandler("pause", function() {});
                navigator.mediaSession.setActionHandler("seekbackward", function() {});
                navigator.mediaSession.setActionHandler("seekforward", function() {});
                navigator.mediaSession.setActionHandler("previoustrack", function() {});
                navigator.mediaSession.setActionHandler("nexttrack", function() {});
            }
        }
    }
}
</script>
